export default __webpack_public_path__ + "static/media/citylitics-logo-logomark-inverse.adc4f47a.png";